var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 7.25C15.4739 7.25 17.1272 7.93482 18.3462 9.15381C19.5652 10.3728 20.25 12.0261 20.25 13.75C20.25 15.36 19.66 16.84 18.69 17.98L18.96 18.25H19.75L24.75 23.25L23.25 24.75L18.25 19.75V18.96L17.98 18.69C16.84 19.66 15.36 20.25 13.75 20.25C12.0261 20.25 10.3728 19.5652 9.15381 18.3462C7.93482 17.1272 7.25 15.4739 7.25 13.75C7.25 12.0261 7.93482 10.3728 9.15381 9.15381C10.3728 7.93482 12.0261 7.25 13.75 7.25ZM13.75 9.25C11.25 9.25 9.25 11.25 9.25 13.75C9.25 16.25 11.25 18.25 13.75 18.25C16.25 18.25 18.25 16.25 18.25 13.75C18.25 11.25 16.25 9.25 13.75 9.25Z",
    fill: "#2196F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.fa627a7f77b3cc8ea9c49199e00efd80.svg";
export { ForwardRef as ReactComponent };